/**
 * @fileoverview
 * Production Environment Configuration
 * 
 * @version 1.0.0
 * @author KATALYST TEAM
 */

import { Environment } from './environment.interface';

export const environment: Environment = {
  workspace: 'dev',
  production: true,

  // API Configuration
  apiUrl: 'https://api.losaudit.katdev.com/api/v1',
  wsUrl: 'wss://api.losaudit.katdev.com/ws',
  
  // Application Configuration
  appName: 'LOS Audit System',
  appVersion: '1.0.0',
  
  // Logging Configuration
  enableLogging: false,
  logLevel: 'error',
  
  // Feature Flags
  features: {
    enableWebSocket: true,
    enableNotifications: true,
    enableAnalytics: true,
    useMockData: false, // Always false in production
  },
  
  // Authentication Configuration
  tokenKey: 'los_audit_token',
  refreshTokenKey: 'los_audit_refresh_token',
  
  // UI Configuration
  itemsPerPage: 10,
  maxFileSize: 5242880, // 5MB in bytes
  allowedFileTypes: ['image/jpeg', 'image/png', 'application/pdf'],
  
  // Timeout Configuration
  httpTimeout: 30000, // 30 seconds
  retryAttempts: 3,
};

